export const locales = ['ru', 'ro', 'en', 'uk'] as const
export const defaultLocale = 'ru' as const
export type Locale = (typeof locales)[number]

// Выбор языка человеком. Одна cookie на всё: её ставит переключатель языка
// (в приложении и в каталоге) и посредник next-intl. Для путей без языкового
// префикса — каталог, портал перевозчика — язык берётся из неё (903).
export const LOCALE_COOKIE = 'NEXT_LOCALE'
